module.exports = __webpack_public_path__ + "img/dine-to-donate-flyer.121aa4a7.png";